import { Link } from "react-router-dom";
import SEOHead from "@/components/feature/SEOHead";
import { OrganizationSchema, WebsiteSchema, WebPageSchema, FAQSchema } from "@/components/feature/SchemaOrg";
import ArticleCard from "@/components/base/ArticleCard";
import { articles, categories, faqData, siteInfo } from "@/mocks/articles";

export default function HomePage() {
  const featuredArticles = articles.filter((a) => a.featured);
  const latestArticles = articles.slice(0, 6);

  const stats = [
    { label: "评测文章", value: "10+", icon: "ri-article-line" },
    { label: "对比平台", value: "4", icon: "ri-apps-line" },
    { label: "评测维度", value: "5+", icon: "ri-radar-line" },
    { label: "用户好评", value: "99%", icon: "ri-thumb-up-line" },
  ];

  return (
    <>
      <SEOHead
        title="蘑菇视频 蘑菇视频-樱花视频樱桃视频糖豆视频哪个好用最好用对比 | 网评资源多不卡顿免费高清使用体验推荐"
        description="蘑菇视频🚨对比樱花视频、樱桃视频、糖豆视频等平台，从资源数量、播放流畅度、🎥免费高清等方面进行口碑评测，哪个最好用？网评推荐。"
        keywords="蘑菇视频,樱花视频,樱桃视频,糖豆视频,最好用,网评,资源多,不卡顿,免费高清,使用体验,推荐"
        canonicalUrl="https://mogutv.com"
      />
      <OrganizationSchema />
      <WebsiteSchema />
      <WebPageSchema
        title="蘑菇视频 - 最好用的视频平台评测推荐"
        description={siteInfo.description}
        url="https://mogutv.com"
        breadcrumbs={[{ name: "首页", url: "https://mogutv.com" }]}
      />
      <FAQSchema questions={faqData} />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20interior%20with%20warm%20amber%20and%20coral%20glowing%20accents%2C%20large%20illuminated%20screen%2C%20luxurious%20velvet%20seats%2C%20atmospheric%20smoke%2C%20rich%20warm%20lighting%2C%20elegant%20movie%20premiere%20vibe%2C%20dramatic%20yet%20inviting%20mood&width=1600&height=700&seq=mogutv-hero-bg&orientation=landscape"
            alt="蘑菇视频 - 最好用的视频平台评测推荐"
            className="absolute inset-0 w-full h-full object-cover object-top"
            title="蘑菇视频 - 最好用的视频平台评测推荐"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <span className="inline-block px-4 py-1.5 bg-accent-500/90 text-white text-xs font-medium rounded-full mb-6">
              🚨 2026最新视频平台评测
            </span>
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 max-w-3xl mx-auto leading-tight">
              蘑菇视频 vs 樱花视频 樱桃视频 糖豆视频
            </h1>
            <p className="text-base md:text-lg text-background-200/90 mb-2 max-w-2xl mx-auto">
              哪个最好用？网评资源多不卡顿免费高清使用体验推荐
            </p>
            <p className="text-sm text-background-300/80 mb-8 max-w-xl mx-auto">
              从资源数量、播放流畅度、免费高清画质等多维度全面对比，帮你找到最好用的视频平台
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/recommend"
                className="px-6 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
              >
                查看评测推荐
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/category/all"
                className="px-6 py-3 bg-background-50/15 text-white font-medium rounded-md hover:bg-background-50/25 backdrop-blur-sm transition-all duration-300 cursor-pointer whitespace-nowrap text-sm border border-background-50/20"
              >
                浏览全部评测
              </Link>
            </div>
          </div>
        </section>

        {/* Stats Bar */}
        <section className="w-full bg-background-50 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 py-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                    {stat.value}
                  </span>
                  <p className="text-xs text-foreground-600 mt-1 flex items-center justify-center gap-1">
                    <i className={`${stat.icon} text-primary-400`}></i>
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="w-full bg-background-100/70 py-14 md:py-18">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                精选评测
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                热门视频平台对比评测
              </h2>
              <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                精选最热门的视频平台对比评测文章，帮你快速了解各平台的优劣
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
            <div className="text-center mt-8">
              <Link
                to="/category/all"
                className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
              >
                查看全部评测文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="w-full bg-background-50 py-14 md:py-18">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                按评测维度浏览
              </h2>
              <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                根据你最关心的维度，找到对应的评测内容
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {categories.filter((c) => c.slug !== "all").map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group block bg-background-100/80 rounded-lg p-6 border border-background-200/60 cursor-pointer transition-all duration-300 hover:border-primary-300/60 hover:bg-background-50"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-200 transition-colors">
                    <i className="ri-folder-open-line text-primary-600 text-lg"></i>
                  </div>
                  <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="w-full bg-background-100/70 py-14 md:py-18">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                最新评测文章
              </h2>
              <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                持续更新的视频平台评测内容，掌握最新口碑动态
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full bg-background-50 py-14 md:py-18">
          <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                常见问题解答
              </h2>
              <p className="text-sm text-foreground-600">
                关于视频平台选择的常见疑问，这里都有答案
              </p>
            </div>
            <div className="flex flex-col gap-3">
              {faqData.map((faq, index) => (
                <details key={index} className="group bg-background-100/80 rounded-lg border border-background-200/60 overflow-hidden cursor-pointer">
                  <summary className="flex items-center justify-between p-4 text-sm font-medium text-foreground-900 list-none">
                    <span className="flex items-center gap-2">
                      <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold flex-shrink-0">
                        Q
                      </span>
                      {faq.question}
                    </span>
                    <i className="ri-arrow-down-s-line text-foreground-400 transition-transform group-open:rotate-180"></i>
                  </summary>
                  <div className="px-4 pb-4 pl-11">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative w-full py-16 md:py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20coral%20and%20amber%20flowing%20waves%2C%20elegant%20modern%20design%2C%20smooth%20organic%20shapes%2C%20minimal%20geometric%20patterns%2C%20cinematic%20atmosphere%2C%20dark%20bottom%20fading%20upwards%20to%20warm%20light&width=1600&height=500&seq=mogutv-cta-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-foreground-950/75"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
              还在犹豫选哪个视频平台？
            </h2>
            <p className="text-sm text-background-300/80 mb-8 max-w-lg mx-auto">
              查看我们的完整评测对比，找到最适合你的视频平台
            </p>
            <Link
              to="/category/recommend"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-white font-medium rounded-md hover:bg-accent-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
            >
              立即查看推荐排行 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>
    </>
  );
}